import Handlebars from "handlebars";

Handlebars.registerHelper("fbPartial", function (obj, field) {
  var partialName = "form_builder_elements/_" + obj[field];
  return obj && partialName;
});
